import { render, staticRenderFns } from "./popEditSend.vue?vue&type=template&id=0f02849a&scoped=true"
import script from "./popEditSend.vue?vue&type=script&lang=js"
export * from "./popEditSend.vue?vue&type=script&lang=js"
import style0 from "./popEditSend.vue?vue&type=style&index=0&id=0f02849a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_71321242e37ff7a0c7584d931db29eba/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f02849a",
  null
  
)

export default component.exports